import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { errorStore } from '../../stores/ErrorStore';
import { EditorNotificationsErrorsWithWithContainer } from '../editor/EditorNotifications';
import { Overlay } from '../menu/PopupSubMenu';
import { CenterContainer, PopupWindow } from '../shared/PopupComponents';
export const RestartingAfterLoggingOutNotification = observer(() => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(PopupWindow, null, t("editor.auth_logging_out"))), errorStore.hasErrors && /*#__PURE__*/React.createElement(EditorNotificationsErrorsWithWithContainer, null));
});